import { createContext } from 'react';

type TFilterableContext = {
  filter: TemplatesFilter;
  setFilter: Function;
};

export const TemplateFilterableContext = createContext<TFilterableContext>(undefined!);
